import 'amfe-flexible'
import {
    createApp
} from 'vue'
import App from './App.vue'
import store from '../../store'
import '@/assets/css/global.css'
import vants from '@/methods/vant.js';
export default function () {
    const app = createApp(App)
    app.use(vants)
    app.use(store)
    return app
}